import { Group } from "@mixitone/models";
import type { List } from "@mixitone/oom";
import { isNil } from "@mixitone/util";

/** Fractional index between two groups in a sorted list (by array position). */
export function generateMidIndex(groups: List<Group>, beforeIndex: number, afterIndex: number) {
  const priorIndex = groups[beforeIndex]?.index;
  const nextIndex = groups[afterIndex]?.index;
  if (isNil(priorIndex) && isNil(nextIndex)) {
    return beforeIndex + 1;
  }
  if (isNil(priorIndex)) {
    return nextIndex! - 0.5;
  }
  if (isNil(nextIndex)) {
    return priorIndex! + 0.5;
  }
  return (priorIndex! + nextIndex!) / 2;
}

/** Index for a new group inserted after `afterId`, or at the start of the list when omitted. */
export async function indexForNewGroup(groups: List<Group>, afterId?: string) {
  if (afterId) {
    const afterIndex = groups.findIndexById(afterId);
    if (afterIndex < 0) {
      throw new Error(`group with id ${afterId} not found`);
    }
    return generateMidIndex(groups, afterIndex, afterIndex + 1);
  }

  if (groups[0]?.index === 0) {
    groups[0].index = generateMidIndex(groups, 0, 1);
    await Group.saveBatch(groups);
  }
  return generateMidIndex(groups, 0, 1);
}
